import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { footerData } from '../data/mock';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo-wrapper">
              <img 
                src="https://customer-assets.emergentagent.com/job_decision-helper-app/artifacts/4ptnwsm9_fc_flower_blue.png" 
                alt="Find Clarity Logo" 
                className="footer-logo-image"
              />
              <h3 className="footer-logo">FindClarity</h3>
            </div>
            <p className="footer-tagline">{footerData.tagline}</p>
          </div>

          <div className="footer-links-section">
            <div className="footer-links-column">
              <h4 className="footer-column-title">Explore</h4>
              <Link to="/blogs" className="footer-link">Blogs</Link>
            </div>

            <div className="footer-links-column">
              <h4 className="footer-column-title">Legal</h4>
              <Link to="/privacy" className="footer-link">Privacy Policy</Link>
              <Link to="/terms" className="footer-link">Terms & Conditions</Link>
              <Link to="/data-deletion-request" className="footer-link">Data Deletion Request</Link>
            </div>

            <div className="footer-links-column">
              <h4 className="footer-column-title">Support</h4>
              <a 
                href={`mailto:${footerData.supportEmail}`} 
                className="footer-link footer-email"
              >
                <Mail size={16} />
                {footerData.supportEmail}
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">{footerData.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
